<template>
  <vue-scroll @handle-scroll="handleScroll">
    <div :key="this.rootKey">
      <div
          id="app"
          :class="`${this.isAuth ? 'wrap ' : ''}default_app ${this.isHamburgerVisible ? 'hamburgerVisible' : 'hamburgerInVisible'}`"
      >
        <router-view></router-view>
      </div>
      <!-- modal component -->
      <PatientAppendModal/>
      <BlankModal/>
      <ResponsiveInfoModal/>
      <AgreementModal/>
      <RemoteView v-if="!notNewWindow"/>
      <ScheduleCalendar/>
      <YesOrNo/>
      <Cookies/>
      <ChangeServicePlanModal
          name="change-service-plan-modal-app"
          @getMyPurchaseSummaryFromServer="getMyPurchaseSummaryFromServer"
          @onClick="handleClick"
      />
      <CommonAlert/>
      <ConfirmModal/>
      <audio id="yourAudio"/>
      <transition name="sessionError">
        <div
            v-if="this.open"
            id="sessionError"
            class="sessionError"
        >
          {{this.open ? $t(`alert.sessionError`, {seconds : this.sessionSeconds - this.diffSeconds}) : ' '}}
        </div>
      </transition>
    </div>
  </vue-scroll>
</template>
<script>
import {mapGetters, mapActions} from "vuex";
import {setCookie, getCookie} from '@/static';
import _API from '@/api'

export default {
  name: 'Home',
  components: {
    RemoteView: () => import('./views/RemoteView'),
    BlankModal: () => import('./components/modal/blankModal/index'),
    YesOrNo: () => import('@/components/modal/yesOrNo/index'),
    PatientAppendModal: () => import('@/components/modal/patientAppend/index'),
    CommonAlert: () => import('@/components/modal/commonAlert/index'),
    ConfirmModal: () => import('@/components/modal/confirmModal/index'),
    ResponsiveInfoModal: () => import('@/components/modal/responsiveInfo/index'),
    AgreementModal: () => import('@/components/modal/agreementModal'),
    ScheduleCalendar: () => import('@/components/modal/scheduleCalendar'),
    Cookies: () => import('@/components/modal/cookies'),
    ChangeServicePlanModal: () => import('@/components/modal/payments/changeServicePlanModal'),
  },
  data() {
    return {
      isAuth: false,
      isHamburgerVisible: false,
      rootKey: 0,
      notNewWindow: false,
      diffSeconds: 0,
      sessionSeconds: 30 * 60,
      sessionViewSeconds: 60,
      // sessionSeconds: 15, // 65초 세션 유지
      // sessionViewSeconds: 10, // 60초 전 알림
      open: false,
      timerFunc: undefined,
    }
  },
  watch: {
    $route: {
      deep: true,
      handler() {
        this.isAuth && this.checkLive();
        // url 에서 언어가 있는 경우
        if (this.$route.query?.lang) {
          localStorage.setItem('lang', this.$route.query.lang);
          this.$i18n.locale = this.$route.query.lang;
        }
      }
    },
  },
  beforeCreate() {
    const language = navigator?.language || navigator?.userLanguage;
    let currentLang = localStorage.getItem('lang') ?? language;
    const korean = currentLang.includes('ko');
    const chinese = currentLang.includes('zh');
    const czech = currentLang.includes('cs');

    if (korean) {
      currentLang = 'ko-kr';
      // TODO: 중국어 운영 배포시 URL 체크 삭제
    } else if (!window.location.href.includes('https://manager.rebless.clinic') && chinese) {
      currentLang = 'zh';
      // TODO: 체코어 운영 배포시 URL 체크 삭제
    } else if (!window.location.href.includes('https://manager.rebless.clinic') && czech) {
      currentLang = 'cs';
    } else {
      currentLang = 'en';
    }

    try {
      if (!window.location.href.includes('https://manager.rebless.clinic')) {
        const devId = () => {
          function _s4() {
            return ((1 + Math.random()) * 0x10000 | 0).toString(16).substring(1);
          }

          return _s4() + _s4() + '-' + _s4() + '-' + _s4() + '-' + _s4() + '-' + _s4() + _s4() + _s4();
        };

        localStorage.setItem('devId', devId());
      }
    } catch (e) {

    }

    localStorage.setItem('lang', currentLang);
    this.$i18n.locale = currentLang;
  },
  created() {
    this.getRootKeyAsync().then(rootKey => {
      this.rootKey = rootKey
    });

    this.unsubscribe = this.$store.subscribe((_mutation, state) => {
      this.isAuth = state.auth.isAuth;
      this.isHamburgerVisible = state.isHamburgerVisible;
      this.rootKey = state.rootKey;
    });

    this.changeDeviceBrowser();
    this.notNewWindow = this.getDeviceBrowser()?.notNewWindow;
  },
  mounted() {
    // 단위를 설정했는지, 로컬스토리지를 확인하고,
    const unit = localStorage.getItem('unit');
    if (!unit && typeof unit === "object") { // 없을 경우 초기값을 미터법으로 세팅한다.
      localStorage.setItem("unit", 'imperial');
      this.changeUnitToVueX('imperial');
    } else {
      this.changeUnitToVueX(unit);
    }

    const appHeight = () => {
      const doc = document.documentElement
      doc.style.setProperty('--app-scroll', `${document.documentElement.scrollLeft}px`);
      doc.style.setProperty('--app-height', `${window.innerHeight}px`)
      doc.style.setProperty('--app-width', `${window.innerWidth}px`)

      if (window.innerHeight > 767)
        doc.style.setProperty('--app-schedule-height', `600px`)
      else
        doc.style.setProperty('--app-schedule-height', `${window.innerHeight - 150}px`)
    }

    window.addEventListener('resize', this.handleResize);
    window.addEventListener('click', this.handelEvent);
    window.addEventListener('mousedown', this.handelEvent);
    window.addEventListener('mouseup', this.handelEvent);
    window.addEventListener('keyup', this.handelEvent);
    window.addEventListener('keydown', this.handelEvent);
    window.addEventListener('wheel', this.handelEvent);
    window.addEventListener('resize', appHeight)
    appHeight()

    this.intervalId = setInterval(() => {
      // 원격진료 창이 열려있고, 상태값이 waiting 이면 동작시간 갱신
      if (this.$store.getters.getVideoCallOpen === true && this.$store.getters.getVideoCallStatus !== 'waiting')
        localStorage.setItem('time', this.moment());

      // 현재시간과 동작시간의 초단위 차이 계산
      this.diffSeconds = Math.round(this.moment.duration(this.moment().diff(localStorage.getItem('time'))).asSeconds());

      // 로그인전 접근할 수 있는 페이지가 아닐경우만 해당 로직 수행
      if (!['/login', '/findPassword', '/signUp'].includes(window.location.pathname)) {
        this.open = this.diffSeconds > 1 && this.sessionSeconds - this.diffSeconds <= this.sessionViewSeconds;
        // 지정한 차이 시간과 같거나 크면 로직 수행
        if (this.diffSeconds >= this.sessionSeconds && localStorage.getItem('refreshToken') !== null) {
          // FCM 사용 가능하면 로직 수행
          if (this.$fbConf.isSupported)
            _API.USER.updateFcmToken('')
                .then(({data}) => {
                  if (data.isSuccess)
                    this.$fbConf.REMOVE_ALL_NOTI_ITEMS_FROM_DB();
                })

          localStorage.setItem('fcmToken', '');
          localStorage.setItem('refreshToken', '');
          localStorage.setItem('accessToken', '');
          this.logOut();
          window.location.href = '/login'
        } else if (localStorage.getItem('refreshToken') === null) {
          window.location.href = '/login'
        }
      } else {
        this.open = false;
      }
    }, 1000)
  },
  beforeDestroy() {
    this.unsubscribe();
    window.removeEventListener('resize', this.handleResize);
    window.removeEventListener('click', this.handelEvent);
    window.removeEventListener('mousedown', this.handelEvent);
    window.removeEventListener('mouseup', this.handelEvent);
    window.removeEventListener('keyup', this.handelEvent);
    window.removeEventListener('keydown', this.handelEvent);
    window.removeEventListener('wheel', this.handelEvent);
    clearInterval(this.intervalId)
  },
  methods: {
    ...mapGetters(['getRootKeyAsync', 'getDeviceBrowser']),
    ...mapActions(['changeUnitToVueX', 'changeBrowserSize', 'changeDeviceBrowser', 'changeLatestPurchaseInfo', 'refreshScheduleForToday', 'logOut']),
    handleScroll(vertical, horizontal, nativeEvent) {
      if (this.timerFunc !== undefined)
        clearTimeout(this.timerFunc);

      this.timerFunc = setTimeout(function () {
        const doc = document.documentElement
        doc.style.setProperty('--app-scroll', `${horizontal.scrollLeft}px`);
      }, 100);
    },
    goBack() {
      window.history.length > 1
          ? this.$router.go(-1)
          : this.$router.push('/')
    },
    handelEvent() {
      this.open = false;
      localStorage.setItem('time', this.moment());
    },
    handleResize() {
      if (this.$store.state.browserSize.width !== window.innerWidth) {
        this.changeBrowserSize({
          width: window.innerWidth,
          height: window.innerHeight,
        })
      }
    },
    checkLive() {
      // TODO: 운영 반영시 제거
      const live = process.env.VUE_APP_MODE === 'LIVE';
      const payPage = window.location.href.includes('/payments');

      if (!live && !payPage)
        this.setPurchaseInfo();
    },
    stateDataSetting(purchase = {}, patients = {}, myPurchase = {}) {
      // 구독 여부
      let isSubscribeActive = purchase?.isSubscribeActive || false;
      // 결제 상태
      let subscribeStatus = purchase?.subscribeStatus || false;
      // 유예 기간
      let isGracePeriod = purchase?.isGracePeriod || false;
      // 최대 환자 수
      let productPatientProfileLimit = myPurchase?.currentSubscriptionInfo?.productPatientProfileLimit || 30;
      const activeCnt = patients?.patientList.filter(item => item.check === true)?.length || 0;

      // 구독중이 아니라면(무료사용자) 결제 성공으로 처리
      subscribeStatus = !isSubscribeActive ? true : subscribeStatus;
      // 구독중이라면 현재 인원수, 아니면 무료 요금제 수
      productPatientProfileLimit = isSubscribeActive ? productPatientProfileLimit : 30;
      // 최대 인원이 0명 (무제한) 일경우 10만명으로..
      productPatientProfileLimit = myPurchase?.currentSubscriptionInfo?.productPatientProfileLimit === 0 ? 100000 : productPatientProfileLimit;
      // 환자수 초과 여부
      let limit = productPatientProfileLimit < activeCnt;

      // // TODO: 테스트 코드 (전체 활성화)
      // const patientList = patients?.patientList
      //     .map(item => item.patientInfo.seqMedicalRelation);
      //
      // Promise.all(patientList.map((item) => {
      //   return _API.PATIENT.changeActivationStatus(item, true);
      // })).then((res) => {
      //   this.$modal.hide('confirm-modal');
      //   this.$router.push('/');
      // })

      // TODO: 테스트 코드 (상태값 변경)
      // // 구독 결제 상태 (true : 정상 / false : 비정상)
      // subscribeStatus = true;
      // // 유예기간 상태 (true : 유예기간 / false : 유예기간아님)
      // isGracePeriod = false;
      // // 환자 초과 상태 (true : 초과 / false : 초과아님)
      // limit = true;
      // // 구독 상태 (true : 유료 / false : 무료)
      // isSubscribeActive = true;

      console.log(
          '구독여부', purchase?.isSubscribeActive || false,
          '결제상태여부', purchase?.subscribeStatus || false,
          '유예기간여부', purchase?.isGracePeriod || false,
          '환자초과여부', limit,
          '환자수(활성화)', activeCnt,
          '환자수(최대)', productPatientProfileLimit,
      );

      return {
        isSubscribeActive, subscribeStatus, isGracePeriod, limit, productPatientProfileLimit
      }
    },
    setPurchaseInfo() {
      // 결제 정보 상태 확인 API
      const purchase = _API.PAYMENT.getSubscriptionStatus();
      // 등록 인원수 확인 API
      const patients = _API.PATIENT_LIST.getMyPatientsAndReservedSchedulesForToday();
      const param = {
        startDatetime: this.moment.tz(this.moment(new Date()).format('YYYY-MM-DD'), this._TIME_ZONE).format(),
        endDatetime: this.moment.tz(this.moment(new Date().addDays(3650)).format('YYYY-MM-DD'), this._TIME_ZONE).add({h: 24}).format()
      };
      // 등록 스케줄 API
      const schedule = _API.SCHEDULE.getAllScheduleByRangeForClinic(param);
      // 결제 개요
      const myPurchase = _API.PAYMENT.getMyPurchaseSummary();

      const APIList = [
        purchase,
        patients,
        schedule,
        myPurchase,
      ]

      Promise.all(APIList)
          .then((data) => {
            const stateData = this.stateDataSetting(data[0]?.data, data[1]?.data, data[3]?.data);

            const isSubscribeActive = stateData.isSubscribeActive;
            const subscribeStatus = stateData.subscribeStatus;
            const isGracePeriod = stateData.isGracePeriod;
            const limit = stateData.limit;
            const productPatientProfileLimit = stateData.productPatientProfileLimit;

            const value = {
              isSubscribeActive: isSubscribeActive,
              paymentInfo: {
                defaultProductSubTitle: data[3]?.data?.currentSubscriptionInfo?.defaultProductSubTitle,
                defaultProductTitle: data[3]?.data?.currentSubscriptionInfo?.defaultProductTitle,
                paymentType: data[3]?.data?.currentSubscriptionInfo?.paymentType,
                productPatientProfileLimit: productPatientProfileLimit,
                seqProduct: data[3]?.data?.currentSubscriptionInfo?.seqProduct,
              }
            };

            if (!subscribeStatus && isGracePeriod) {
              // 결제 오류 / 유예기간 O
              if (getCookie("payPopup") !== 'N') {
                this.$modal.show('common-alert-modal', {
                  messageType: 'short',
                  message: '결제 오류로 인한 서비스 이용 유예기간 입니다.',
                });
                setCookie("payPopup", "N", 1);
              }
            } else if ((subscribeStatus && limit) || (!subscribeStatus && !isGracePeriod && limit)) {
              // 결제 정상 / 환자수 초과
              // 결제 오류 / 유예기간 지남 / 환자수 초과
              const handleClick = () => {
                if (document.getElementsByName('check-payments').length === 0) {
                  this.$modal.show('common-alert-modal', {
                    messageType: 'short',
                    message: '비정상적인 돔 상태 (새로고침 합니다.)',
                    function: () => {
                      window.location.reload();
                    }
                  });
                }
              };

              window.addEventListener('click', handleClick);

              this.$modal.show('confirm-modal', {
                name: 'check-payments',
                width: 475,
                header: '서비스 이용 제한',
                description: '활성화 되어 있는 환자수가 등록가능한 환자수를 초과하였습니다.',
                confirmFunction: {
                  button: '결제',
                  func: async () => {
                    await window.removeEventListener('click', handleClick);
                    await this.$modal.hide('confirm-modal');

                    if (isSubscribeActive) {
                      // 결제 정상 일경우 플랜 변경
                      await this.$modal.show('change-service-plan-modal-app', value.paymentInfo);
                    } else {
                      // 결제 비정상일경우 다시 결제
                      await this.$router.push('/payments');
                    }
                  },
                  params: []
                },
                subFunction: {
                  button: '환자 비활성화 (서비스 이용)',
                  func: async () => {
                    await window.removeEventListener('click', handleClick);
                    // 전체 비활성화 API
                    // _API.PATIENT.disableAllUnscheduledPatients()
                    //     .then(({data}) => {
                    //     })

                    // TODO: 건단위로 만들어서... 테스트 후 위에 껄로
                    const patientList = data[1]?.data?.patientList
                        .map(item => item.patientInfo.seqMedicalRelation);
                    const scheduleList = data[2]?.data?.scheduleList
                        .filter(item => item.scheduleStatus === 0)
                        .map(item => item.seqMedicalRelation);
                    const unActiveList = patientList
                        .filter(item => !scheduleList.includes(item));

                    await Promise.all(unActiveList.map((item) => {
                      return _API.PATIENT.changeActivationStatus(item, false);
                    })).then(() => {
                      this.refreshScheduleForToday(true);
                      this.$modal.hide('confirm-modal');
                    })
                  },
                  params: []
                },
                close: false
              });
            }

            this.changeLatestPurchaseInfo(value);
          })
          .catch(() => {
            // This is intentional
          })
    },
    getMyPurchaseSummaryFromServer() {
      this.$emit('getMyPurchaseSummaryFromServer');
    },
    handleClick() {
      this.checkLive();
    },
  },
}
</script>
<style lang="scss">

.default_app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  /*margin-top: 60px;*/
  background: #efefef;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.landing {
  display: flex;
  justify-content: center;
  align-items: center;
  height: var(--app-height);
  background: #fff;
  width: 100vw;
}

.sessionError {
  border-radius: var(--pannel-radius);
  color: var(--warning20);
  background-color: var(--warning10);
  position: fixed;
  width: calc(100% - 100px);
  bottom: 10px;
  left: 50%;
  transform: translate(-50%, 0%);
  padding: 20px;
  z-index: 999999;
  cursor: pointer;
  opacity: 0.8;
}

.sessionError-enter-active,
.sessionError-leave-active {
  transition: opacity 0.5s ease;
}

.sessionError-enter-from,
.sessionError-leave-to {
  opacity: 0;
}
</style>